export default "<app-loader></app-loader>\n<router-outlet></router-outlet>"